import styled from '@emotion/styled';

export const PaginationContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  '& .MuiTypography-root': {
    marginRight: '20px',
  },
});
